import type { SVGProps } from "react";
export interface StreetViewIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StreetViewIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StreetViewIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.035 15.585a1.125 1.125 0 0 1 .589 2.17c-.951.258-1.652.565-2.086.862-.29.199-.378.332-.404.384.022.043.087.14.27.283.314.247.839.52 1.587.77 1.486.495 3.611.82 6.009.82s4.523-.325 6.009-.82c.748-.25 1.273-.523 1.588-.77.18-.143.245-.24.268-.283-.027-.052-.114-.186-.403-.384-.325-.223-.8-.45-1.418-.66l-.665-.2-.11-.036a1.124 1.124 0 0 1 .586-2.161l.113.025.398.114c.918.277 1.736.63 2.367 1.062.69.472 1.392 1.212 1.392 2.238 0 .907-.552 1.593-1.135 2.053-.597.47-1.39.843-2.27 1.136-1.772.59-4.148.936-6.72.936s-4.948-.345-6.72-.936c-.88-.293-1.673-.666-2.27-1.136-.547-.431-1.066-1.06-1.13-1.884l-.005-.169.009-.189c.08-.929.736-1.606 1.383-2.049.722-.495 1.688-.884 2.768-1.176"
      />
      <path
        fill={color}
        d="M12.876 4a.876.876 0 1 0-1.752.002A.876.876 0 0 0 12.876 4m1.5 7a.875.875 0 0 0-.877-.874h-3a.875.875 0 0 0-.874.874v1.441a2.12 2.12 0 0 1 1.56 1.626l.032.198.29 2.61h.986l.29-2.61.031-.198a2.13 2.13 0 0 1 1.562-1.626zm2.25 2c0 .895-.726 1.621-1.62 1.624l-.339 3.056a1.625 1.625 0 0 1-1.614 1.445h-2.105a1.626 1.626 0 0 1-1.591-1.293l-.025-.152-.34-3.056a1.625 1.625 0 0 1-1.617-1.625V11a3.125 3.125 0 0 1 3.124-3.125h3A3.125 3.125 0 0 1 16.625 11v2Zm-1.5-9a3.126 3.126 0 1 1-6.25 0 3.126 3.126 0 0 1 6.25 0"
      />
    </svg>
  );
}
